window.skrollr = require 'skrollr/src/skrollr'

class MPP.ImageParallax

  constructor: ({@el, @pixelsToScroll}) ->
    @$el = $ @el

    # do not use parallax on mobile
    return unless $(window).width() >= 768

    # do not initialize skrollr if the viewport is too small and there's no hero image
    background = @$el.css 'background-image'
    return if not background? or background is 'none'

    @parallaxHandler = window.skrollr.init
      mobileCheck: -> false # disable mobile scrolling hacks that slow down the page on mobile phones
      forceHeight: false # this disables setting the body height because it was causing issues (which means the image won't scroll if the page is not long enough)

    @refresh()

    $(window).resize => @refresh()

  refresh: ->
    return unless @$el?.length
    @setImageSize()

  setStopsBasedOnHeight: (height, initialVerticalPosition) ->
    heightOfHeroImageAndHeader = @$el.height() + @$el.offset().top
    @$el.attr('data-0', "background-position: center #{initialVerticalPosition}px;")
    @$el.attr("data-#{heightOfHeroImageAndHeader}", "background-position: center #{(initialVerticalPosition - @pixelsToScroll)}px;")
    @parallaxHandler.refresh()

  setImageSize: ->
    imageUrl = @$el.css 'background-image'

    # remove url() or url("")
    imageUrl = imageUrl.match(/^url\("?(.+?)"?\)$/)?[1]
    return unless imageUrl

    img = new Image()

    $(img).load =>
      # First, we try to set the height to the minimum possible (the height of the hero image space + space for scrolling)
      # and we scale the width to match this new height.
      height = @$el.height() + @pixelsToScroll * 2
      width = Math.ceil((height * img.width) / img.height)
      initialVerticalPosition = 0
      if width < @$el.width()
        # If the image width doesn't fill the whole page with this new dimensions, then we try to do it the other way around:
        # We set the width to fill the whole page and scale the height to match this new width.
        width = @$el.width()
        height = Math.ceil((width * img.height) / img.width)
        # Then we center the image.
        initialVerticalPosition = -1 * Math.floor((height - @$el.height()) / 2)

      @$el.css 'background-size', "#{width}px #{height}px"
      @$el.css 'background-position', "center #{initialVerticalPosition}px"

      @setStopsBasedOnHeight height, initialVerticalPosition

    img.src = imageUrl

$ ->
  el = '.merchant-header > .merchant-hero-image'
  return unless $(el).length > 0

  headerConfig = $(el).data()

  new MPP.ImageParallax({
    el: el,
    pixelsToScroll: headerConfig.pixelsToScroll
  })
